export default __webpack_public_path__ + "static/media/sports (6).1add7877.jpg";